import { LuSearch, BsThreeDots } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "40%",
      rows: {
        row1: [
          {
            name: "exporterId",
            label: "Exporter",
            component: "text-field",
            placeholder: "Select Exporter",
            type: "autocomplete",
            endpoint: "getCustomers",
            icon: LuSearch,
            autofillTargets: {
              exporterAddressId: "address",
              exporterAddress: "addressLine",
              State: "state",
              exportBranchSerialNumber: "branchSNo",
              exportIECodeNumber: "ieCodeNo",
              exportRegistrationNumber: "regNo"
            },
            required: true,
            endPointWithId : "getCustomersAddress"

          },
          {
            name: "New1",
            label: "New",
            component: "outlinebutton",
            action: "navigate",
            variant: "bodySmallMedium",
            navigateTo: "/export/create-customer",
            width: "10%",
            sx: {
              mt: "32px",
            },
            disable: true,
          },
        ],
        row2: [
          {
            name: "exporterAddressId",
            label: "Address",
            component: "dropdown",
            width: "100%",
            type: "autocomplete",
            endIconName: "LuChevronDown",
            autofillTargets: {
              exporterAddress: "addressLine",
              State: "state",
              // exportBranchSerialNumber: "branchSNo",
              // exportIECodeNumber: "ieCodeNumber",
            },
          },
        ],
        row3: [
          {
            name: "exporterAddress",
            component: "textarea",
            width: "100%",
            height: 100,
            sx: {
              borderRadius: 10,
            },
            disabled: true,
            isGet: false,
          },
        ],
        row4: [
          {
            name: "exportBranchSerialNumber",
            label: "Branch SNO",
            component: "text-field",
            width: "35%",
            disabled: true,
            isGet: false,
          },
          {
            name: "State",
            label: "State",
            component: "text-field",
            width: "65%",
            disabled: true,
            isGet: false,
          },
        ],
        row5: [
          {
            name: "exportIECodeNumber",
            label: "IE Code",
            component: "text-field",
            width: "100%",
            disabled: true,
          },
        ],
        row6: [
          {
            name: "exportRegistrationNumber",
             label: "Regn.Type",
            component: "text-field",
            width: "50%",
            // icon: LuSearch,
            iconColor: "gray-400",
            
          },
          {
            name: "exportRegistrationType",
            label: "Regn.No",
            options: [
              {
                label: "GSTIN of Normal Person /Individual IEC",
                value: "GSTIN of Normal Person /Individual IEC",
              },
              {
                label: "GSTIN of Government Entities",
                value: "GSTIN of Government Entities",
              },
              { label: "GSTIN of Diplomats", value: "GSTIN of Diplomats" },
              {
                label: "GSTIN of Non-Resident Taxable Person",
                value: "GSTIN of Non-Resident Taxable Person",
              },
              { label: "PAN Number", value: "PAN Number" },
              { label: "TAN Number", value: "TAN Number" },
              { label: "Passport No", value: "Passport No" },
              { label: "Aadhar Number", value: "Aadhar Number" },
            ],
            value : {
                label: "GSTIN of Normal Person /Individual IEC",
                value: "GSTIN of Normal Person /Individual IEC",
              },
            component: "dropdown",
            width: "50%",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            // disabled: true,
          },
        ],
        row7: [
          {
            name: "exportDBKBank",
            label: "DBK Bank",
            component: "text-field",
            width: "90%",
          },
          {
            name: "DBKBankList",
            component: "outlinebutton",
            sx: {
              mt: "33px",
            },
            width: "10%",
            iconName: BsThreeDots,
            iconSpacing: 0,
            iconPosition: "center",
            action: "openSubDialog",
            subComponent: "DBKBankList",
          },
        ],
        row8: [
          {
            name: "exportDBKAccountNumber",
            label: "DBK A/c.",
            component: "text-field",
            width: "100%",
          },
        ],
        row9: [
          {
            name: "exportDBKEDIAccountNumber",
            label: "DBK EDI A/c.",
            component: "text-field",
            width: "100%",
          },
        ],
        row10: [
          {
            name: "exportConsigneeId",
            label: "Consignee",
            component: "text-field",
            width: "90%",
            type: "autocomplete",
            endpoint: "getCustomers",
            icon: LuSearch,
            autofillTargets: {
              exportConsigneeAddressId: "address",
              exportConsigneeAddress: "addressLine",
              exportConsigneeCountryId: "country",
            },
          endPointWithId : "getCustomersAddress"

          },
          {
            name: "New",
            label: "New",
            component: "outlinebutton",
            variant: "bodySmallMedium",
            width: "10%",
            action: "navigate",
            navigateTo: "/export/job/create-customer",
            sx: {
              mt: "32px",
            },
          },
        ],
        row11: [
          {
            name: "exportConsigneeAddressId",
            label: "Address",
            component: "dropdown",
            width: "100%",
            type: "autocomplete",
            endIconName: "LuChevronDown",
            autofillTargets: {
              exportConsigneeAddress: "addressLine",
              exportConsigneeCountryId: "country",
            },
          },
        ],
        row12: [
          {
            name: "exportConsigneeAddress",
            //  actionText: "Address",
            component: "textarea",
            width: "100%",
            height: 100,
            sx: {
              borderRadius: 10,
            },
            displayKey: "exportConsigneeAddress",
          },
        ],
        row13: [
          {
            name: "exportConsigneeCountryId",
            label: "Cons Country",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry",
          },
        ],
        row14: [
          {
            name: "isExportBuyerOtherthanConsignee",
            label: "Buyer, if other than consignee",
            component: "checkboxbox",
          },
        ],
        row15: [
          {
            name: "Note details",
            actionText:
              "Note: Items in italic indicates the fields which are used for EDI file submission",
            component: "typographytext",
            sx: {
              fontWeight: "bold",
            },
            actionTextSx: { fontWeight: 600 },
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "55%",
      rows: {
        row1: [
          {
            name: "exportRefType",
            label: "Ref. Type",
            component: "text-field",
            width: "75%",
            placeholder: "Select  Type",
          },
        ],
        row2: [
          {
            name: "exportRefNumber",
            label: "Exporter Ref No./Date",
            component: "text-field",
            width: "35%",
            placeholder: "Enter the Ref No",
          },
          {
            name: "exportReferenceDate",
            component: "dateselector",
            width: "37%",
            disabled: true,
            dependsOn: "exportRefNumber",
          },
        ],
        row3: [
          {
            name: "exportType",
            label: "Exporter Type",
            options: [
              {
                label: "Manufacturer Exporter",
                value: "Manufacturer Exporter",
              },
              { label: "Merchant Exporter", value: "Merchant Exporter" },
              { label: "Other", value: "Other" },
            ],
            component: "dropdown",
            placeholder: "Manufacturer Exporter",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            width: "75%",
          },
        ],
        row4: [
          {
            name: "exportSBNumber",
            label: "SB Number/Date",
            component: "text-field",
            width: "35%",
            placeholder: "Enter the SB No",
            disabled : true
          },
          {
            name: "exportSBNumberDate",
            component: "dateselector",
            width: "37%",
            disabled: true,
            dependsOn: "exportSBNumber",
            enableWhen: (val) => !!val,
            placeholder: "Enter the SB Date",
          },
        ],
        row5: [
          {
            name: "exportRBIApprovalNumber",
            label: "RBI Appr.No & Date",
            component: "text-field",
            width: "35%",
            placeholder: "Enter the RBI No",
          },
          {
            name: "exportRBIApprovalDate",
            component: "dateselector",
            width: "37%",
            disabled: true,
            dependsOn: "exportRBIApprovalNumber",
            enableWhen: (val) => !!val,
            placeholder: "Enter the RBI Date",
          },
        ],
        row6: [
          {
            name: "exportGRNumber",
            label: "GR No",
            component: "text-field",
            width: "35%",
            placeholder: "Enter GR No",
            unDependsOn: "isExportGRWaived",
            enableWhen: (val) => val,
          },
          {
            name: "exportGRDate",
            width: "37%",
            component: "dateselector",
            disabled: true,
            dependsOn: "exportGRNumber",
            enableWhen: (val) => !!val,
            placeholder: "Enter GR Date",
          },
          {
            type: "single",
            name: "isExportGRWaived",
            checkboxLabel: "GR Waived",
            width: "25%",
            component: "checkboxbox",
            sx: {
              mt: 3,
            },
          },
        ],
        row7: [
          {
            name: "exportRBIWaiverNumber",
            label: "RBI Waiver No",
            component: "text-field",
            width: "35%",
            placeholder: "Enter RBI WaiverNo",
            //  dependsOn: "isExportGRWaived",
            enableWhen: (val) => !!val,
            dependsOn: "isExportGRWaived",
          },
          {
            name: "exportRBIWaiverDate",
            component: "dateselector",
            width: "37%",
            disabled: true,
            dependsOn: "exportRBIWaiverNumber",
            enableWhen: (val) => !!val,
            placeholder: "Enter RBI Waiver Date",
          },
        ],

        row8: [
          {
            name: "exportBankorDealer",
            actionText: "Bank / Dealer",
            component: "textarea",
            width: "91%",
            height: 100,
            sx: {
              borderRadius: 10,
            },
          },
        ],
        row9: [
          {
            name: "exportAccountNumber",
            label: "A/C Number",
            component: "text-field",
            width: "31%",
          },
          {
            name: "A/C Number",
            component: "outlinebutton",
            sx: {
              mt: "33px",
            },
            width: "10%",
            iconName: BsThreeDots,
            iconPosition: "start",
            iconSpacing: 0,
            subComponent : "BankSelectorPopover",
            action : "openButtonDialog"
          },
          {
            name: "exportADCode",
            label: "AD Code",
            component: "text-field",
            width: "30%",
          },
        ],
        row10: [
          {
            name: "exportEPZCode",
            label: "EPZ Code",
            component: "text-field",
            width: "76%",
          },
        ],
        row11: [
          {
            name: "exportNotifyId",
            label: "Notify",
            component: "text-field",
            responseKey: "data",
            iconColor: "gray-400",
            width: "76%",
            type: "autocomplete",
            endpoint: "getCustomers",
            icon: LuSearch,
            autofillTargets: {
              exportNotifyAddressId: "address",
              // notifyAddress: "fullAddress",
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row12: [
          {
            name: "exportNotifyAddressId",
            label: "Address",
            component: "dropdown",
            type: "autocomplete",
            // width: "50%",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            width: "76%",
            autofillTargets: {
              notifyAddress: "addressLine",
            },
          },
        ],
        row13: [
          {
            name: "notifyAddress",
            component: "textarea",
            width: "91%",
            height: 100,
            sx: {
              borderRadius: 10,
            },
          },
        ],
        row14: [
          {
            name: "exportSalesPersons",
            label: "Sales Person",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            width: "63%",
            disabled : true
          },
          {
            name: "exportSalesPerson",
            component: "outlinebutton",
            sx: {
              mt: "33px",
            },
            width: "10%",
            iconName: BsThreeDots,
            iconSpacing: 0,
            iconPosition: "start",
          },
        ],
        row15: [
          {
            name: "exportQuotation",
            label: "Quotation",
            component: "text-field",
            iconColor: "gray-400",
            width: "76%",
          },
        ],
      },
    },
  ],
};
